import { HostListener, Component, ViewChild } from '@angular/core';

import {
    NavController,
    NavParams,
    PopoverController,
    ViewController,
    AlertController,
    LoadingController,
    ToastController,
    ModalController
} from 'ionic-angular';

import { Account } from '../../../../model/account';
import { AccountMembership } from '../../../../model/accountMembership';
import { MembershipHandicap } from '../../../../model/membershipHandicap';
import { Horse } from '../../../../model/horse';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { RodeoEventRegistration } from '../../../../model/rodeoEventRegistration';

import { AlertMessager } from "../../../../lib/alertMessager";
import { EntryService } from "../../../../services/entry.service";
import { UserService } from "../../../../services/user.service";
import { UserSearchPopover } from '../../../search/user-search';
import { AddHorsePage } from '../../../horse/add-horse';
import { PayPal } from '@ionic-native/paypal';
import { BuddyEntry } from '../../../buddy-entry/buddy-entry';
import { RegistrationExhibition } from '../../../../model/registrationExhibition';
import { RegistrationPayment } from '../../../../model/registrationPayment';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';
import { RunService } from '../../../../services/run.service';
import { EntryLogsPage } from './entry-logs';
import { SearchComponent } from '../../../../pages/search/search.component';
import { HorseService } from '../../../../services/horse.service';
import { NewMemberPage } from '../memberships/new-member';
import { RegistrationCarryOver } from '../../../../model/registrationCarryOver';
import { RegistrationClothing } from '../../../../model/registrationClothing';
import { PurchaseOrderComponent } from '../purchase-order/purchase-order.component';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { ChangeRequestDetailsComponent } from '../../change-requests/change-request-details';
import { RodeoService } from '../../../../services/rodeo.service';
import { RequestService } from '../../../../services/request.service';
import { ChangeRequestStatus } from '../../../../model/registration-change-request';
import { DateHelperService } from '../../../../services/date-helper';

@Component({
    selector: 'page-new-entry',
    templateUrl: 'new-entry.html'
})
export class NewEntryPage {
    @ViewChild('userOneSearch') userOneSearch;
    @ViewChild('userTwoSearch') userTwoSearch;
    @ViewChild('horseOneSearch') horseOneSearch;
    @ViewChild('horseTwoSearch') horseTwoSearch;
    @ViewChild('purchaseOrder') purchaseOrder : PurchaseOrderComponent;

    rodeo: Rodeo;
    availableEventTypes: RodeoEvent[] = [];
    rodeoEvent: RodeoEvent;
    selectedEntry: RodeoEventRegistration = new RodeoEventRegistration();

    entryTurnedOut: boolean = false;

    showTeammate: boolean = false;
    showHorse: boolean = false;
    showBuddies: boolean = false;

    addRun: boolean = false;
    enableRunInfo: boolean = false;
    drawPosition: number = 0;

    showPreferences: boolean = false;

    showHorseOne: boolean = false;
    showHorseTwo: boolean = false;

    contestantOneName: string;
    teammateName: string;
    buddyList: string;
    horseOnes: Horse[];
    horseTwos: Horse[];
    selectedExhibitions: number[] = [];
    selectedCarryOvers: any[] = [];

    swapTeammate: boolean;
    editing: boolean;
    popoverActive: boolean = false;
    entries: RodeoEventRegistration[] = [];
    createdEntries: RodeoEventRegistration[] = [];
    firstPrefAnyCounts: number;
    secondPrefTurnoutCounts: number;
    secondPrefAnyCounts: number;
    rodeoEventCarryOvers: Map<string, RodeoEvent[]> = new Map();
    rodeoEventSidepots: Set<RodeoEvent> = new Set<RodeoEvent>();
    existingExhibitionsCounts: number[];

    organizations: any[] = [];

    allHoles: number[] = [];
    addedRunNumbers: number[] = [];

    entryContestants: Account[] = [];
    entryContestantsMap: { [id: number]: Account };
    
    buddySet = new Set<number>();

    constructor(
        private nav: NavController,
        navParams: NavParams,
        private loadingController: LoadingController,
        private popoverController: PopoverController,
        private alertController: AlertController,
        private entryService: EntryService,
        private alert: AlertMessager,
        private userService: UserService,
        private viewController: ViewController,
        private toast: ToastController,
        private paypal: PayPal,
        private modalController: ModalController,
        private runService: RunService,
        private rodeoService: RodeoService,
        private requestService: RequestService,
        public dateHelper: DateHelperService) {
        
        this.rodeo = navParams.get('rodeo');
        this.organizations = navParams.get("organizations");
        let rodeoEvent = navParams.get('rodeoEvent');
        let existingEntry = navParams.get("entry");
        this.addRun = navParams.get("addRun");
        this.enableRunInfo = this.addRun;

        this.addedRunNumbers = [];
        this.availableEventTypes = this.rodeo.rodeoEvents;

        if (rodeoEvent != null) {
            this.rodeoEvent = rodeoEvent;
            this.addRun = rodeoEvent.drawn;
            this.showTeammate = this.rodeoEvent.eventType == 'TeamRoping';
            this.showHorse = rodeoEvent.eventType == 'BarrelRacing'
                || rodeoEvent.eventType == 'BreakawayRoping'
                || rodeoEvent.eventType == 'Tie-Down'
                || rodeoEvent.eventType == 'SteerWrestling';
            this.showBuddies = rodeoEvent.allowBuddies || rodeoEvent.teammateEntry;

            this.showHorseOne = this.rodeoEvent.configuration.entries.showHorseOne;
            this.showHorseTwo = this.rodeoEvent.configuration.entries.showHorseTwo;
        }

        Object.assign(this.selectedEntry, existingEntry);

        if (existingEntry == null || existingEntry == undefined) {
            this.setupNewEntry();
        } else {
            this.editing = true;
            console.log("existingEntry: ", existingEntry);

            if (!existingEntry.run)
                this.enableRunInfo = false;

            this.contestantOneName = this.selectedEntry.contestantOne.firstName + ' ' + this.selectedEntry.contestantOne.lastName;

            if (this.selectedEntry.horseOne != null)
                this.selectedEntry.horseOneName = this.selectedEntry.horseOne.name;

            if (this.selectedEntry.horseTwo != null)
                this.selectedEntry.horseTwoName = this.selectedEntry.horseTwo.name;


            if (this.selectedEntry.contestantTwo != null) {
                this.teammateName = this.selectedEntry.contestantTwo.firstName + ' ' + this.selectedEntry.contestantTwo.lastName;
            }

            if (this.selectedEntry.isDraw) {
                this.teammateName = "Draw";
            }

            if (this.selectedEntry.isTba) {
                this.teammateName = "TBA";
            }

            this.existingExhibitionsCounts = [];
            this.selectedEntry.exhibitions.forEach((exhibition) => {
                this.selectedExhibitions.push(exhibition.exhibitionId);
                this.existingExhibitionsCounts[exhibition.exhibitionId] = exhibition.entryCount;
            });

            if (this.selectedEntry.allPreferences && this.selectedEntry.scheduleIds.length > 0) {
                this.selectedEntry.scheduleIds[1] = -1;
            }

            if ((this.selectedEntry.scheduleIds[1] == -1 || this.selectedEntry.secondPrefTurnout)  && this.selectedEntry.scheduleIds.length >= 1) {
                this.selectedEntry.scheduleIds[1] = this.selectedEntry.scheduleIds[0];
            }

            if (this.selectedEntry.status === 'TurnedOut') {
                this.entryTurnedOut = true;
            }

            this.setMemberships(this.selectedEntry.contestantOne);

            this.userService.getHorses(this.selectedEntry.contestantOneId)
                .then(data => {
                    this.horseOnes = data as Horse[];
                })
                .catch(error => this.alert.showError('Error', 'Unable to retrieve search results: ' + error));

            if (this.selectedEntry.contestantTwo != null) {
                this.setMemberships(this.selectedEntry.contestantTwo);

                this.userService.getHorses(this.selectedEntry.contestantTwoId)
                    .then(data => {
                        this.horseTwos = data as Horse[];
                    })
                    .catch(error => this.alert.showError('Error', 'Unable to retrieve search results: ' + error));
            }

            this.updateEvents();
        }

        this.entries.push(this.selectedEntry);

        this.rodeo.exhibitions.forEach((exhibition) => {
            let existingRegistrationExhibitions = this.rodeo.rodeoEvents.flatMap(x => x.registrations.filter(y => y.status !== "TurnedOut")).flatMap(x => x.exhibitions.filter(y => y.exhibitionId == exhibition.id));
            exhibition.currentCount = existingRegistrationExhibitions.length > 0 ? existingRegistrationExhibitions.map(x => x.entryCount).reduce((a, b) => a + b) : 0;
        });

        if (!this.editing) {
            setTimeout(() => {
                this.focusElement(this.userOneSearch);
            }, 0)
        }

        this.setEntryContestants();
    }

    private focusElement(element) {
        const element2 = element._elementRef.nativeElement.querySelector('input');
        // we need to delay our call in order to work with ionic ...
        setTimeout(() => {
            //this.renderer.invokeElementMethod(element, 'focus', []);
            (element2 as any)['focus'].apply(element2, []);
        }, 0);
    }

    updateEvents() {
        if (this.rodeoEvent != null) {
            this.addRun = this.rodeoEvent.drawn;
            this.rodeoEventCarryOvers = new Map();
            
            if (!this.rodeoEvent.configuration.entries.showContestantTwo)
                this.selectedEntry.teammateHeader = false;

            this.selectedCarryOvers = [];

            this.rodeo.rodeoEvents.filter(x => this.rodeoEvent.carryOvers.some(y => y.carryOverId == x.id)).forEach((carry) => {
                if (!this.rodeoEventCarryOvers.get(this.rodeoEvent.displayName))
                    this.rodeoEventCarryOvers.set(this.rodeoEvent.displayName, []);

                this.rodeoEventCarryOvers.get(this.rodeoEvent.displayName).push(carry);

                var existingCarryOver = this.selectedEntry.carryOvers.filter(x => x.rodeoEventId == carry.id)[0];

                if (existingCarryOver) {
                    this.selectedCarryOvers.push({ from: this.rodeoEvent, to: carry, lateFee: existingCarryOver.lateFee });
                }
            });

            this.updateSidepots();

            this.selectedEntry.rodeoEventId = this.rodeoEvent.id;

            if (!this.selectedEntry.scheduleIds || !this.selectedEntry.scheduleIds.some(x => this.rodeoEvent.schedules.some(y => y.id == x))) {
                for (var i = 0; i < this.selectedEntry.scheduleIds.length; i++) {
                    var prefName = this.rodeo.rodeoEvents.flatMap(x => x.schedules).find(x => x.id == this.selectedEntry.scheduleIds[i]);
                    var matchingPrefByName = this.rodeoEvent.schedules.find(x => x.name.toLowerCase() == prefName.name.toLowerCase());

                    if (matchingPrefByName)
                        this.selectedEntry.scheduleIds[i] = matchingPrefByName.id;
                    else {
                        this.selectedEntry.scheduleIds = [];
                        this.selectedEntry.scheduleIds[0] = this.rodeoEvent.schedules[0].id;

                        if (this.rodeoEvent.preferencesAllowed > 1 && this.rodeoEvent.schedules.length > 1)
                            this.selectedEntry.scheduleIds.push(this.rodeoEvent.schedules[1].id);

                        break;
                    }
                }
            }

            this.showPreferences = this.rodeoEvent.preferencesAllowed >= 1 && this.rodeoEvent.schedules.filter(x => x.blockPreference == false).length > 1;

            this.showTeammate = this.rodeoEvent.eventType == 'TeamRoping';
            this.showHorse = this.rodeoEvent.configuration.entries.showHorseOne || this.rodeoEvent.configuration.entries.showHorseTwo;
            this.showHorseOne = this.showHorse;
            this.showHorseTwo = this.showTeammate && this.showHorse;
            this.showBuddies = this.rodeoEvent.allowBuddies || this.rodeoEvent.teammateEntry;

            if (this.editing && this.selectedEntry.run)
                this.drawPosition = this.selectedEntry.run.number;
            else
                this.nextHole();

            this.allHoles = [];

            let runNumbers = this.rodeo.rodeoEvents[this.rodeo.rodeoEvents.indexOf(this.rodeoEvent)].schedules[0].runs.filter(x => x.round == 1).map(x => x.number);
            runNumbers = runNumbers.concat(this.addedRunNumbers);
            runNumbers.sort((a, b) => {
                if (a < b)
                    return -1;
                else if (a > b)
                    return 1;

                return 0;
            });

            let currentRunNumber = 1;
            let lastRunNumber = 0;
            for (let i = 0; i < runNumbers[runNumbers.length - 1]; i++) {
                if (runNumbers[i] != lastRunNumber)
                    lastRunNumber = runNumbers[i];
                else
                    console.log("Duplicate run number: ", lastRunNumber);

                while (currentRunNumber != runNumbers[i] && runNumbers[runNumbers.length - 1] + 1 >= currentRunNumber && currentRunNumber < runNumbers[i + 1]) {
                    this.allHoles.push(currentRunNumber);
                    currentRunNumber++;
                }

                if (currentRunNumber == runNumbers[i])
                    currentRunNumber++;
            }

            if (runNumbers.length == 0 || runNumbers[runNumbers.length - 1] == runNumbers.length)
                this.allHoles.push(runNumbers.length + 1);

            this.updatePurchaseOrder();
        }
    }

    selectEntry(index) {
        this.selectedEntry = this.entries[index];
        this.selectedExhibitions = [];

        this.selectedEntry.exhibitions.forEach((exhibition) => {
            this.selectedExhibitions.push(exhibition.exhibitionId);
        });
    }

    addNewEntry() {
        this.setupNewEntry();
        this.entries.push(this.selectedEntry);
        this.selectedExhibitions = [];

        this.selectedEntry.exhibitions.forEach((exhibition) => {
            this.selectedExhibitions.push(exhibition.exhibitionId);
        });
    }

    removeEntry(entry) {
        let index = this.entries.indexOf(entry);
        this.entries = this.entries.filter(x => x != entry);
        this.selectedEntry = this.entries.length > index ? this.entries[index] : this.entries[index - 1];
        this.selectedExhibitions = [];

        this.selectedEntry.exhibitions.forEach((exhibition) => {
            this.selectedExhibitions.push(exhibition.exhibitionId);
        });
    }

    updatePreferences() {
        if (this.selectedEntry.scheduleIds[0] == -1)
            this.selectedEntry.allPreferences = true;
        else
            this.selectedEntry.allPreferences = false;

        if (this.selectedEntry.secondPrefTurnout) {
            if (this.selectedEntry.scheduleIds[1] != this.selectedEntry.scheduleIds[0]) {
                this.selectedEntry.secondPrefTurnout = false;
            }
        }

        if (this.selectedEntry.scheduleIds[1] == this.selectedEntry.scheduleIds[0]) {
            if (this.rodeoEvent.schedules.filter(x => x.id == this.selectedEntry.scheduleIds[1])[0].name.indexOf('Slack') != -1) {
                this.selectedEntry.allPreferences = true;
                this.selectedEntry.secondPrefTurnout = false;
            }
            else if (!this.selectedEntry.secondPrefTurnout) {
                this.selectedEntry.secondPrefTurnout = true;
                this.selectedEntry.allPreferences = false;
            }
        }
    }

    matchCarryOvers(a: any, b: any) {
        if (a.from == null && b.from == null)
            return true;
        else if (a.to == null && b.to == null)
            return true;

        return a.from.id == b.from.id && a.to.id == b.to.id;
    }

    matchStrings(a: any, b: any) {
        return a.toLocaleLowerCase() === b.toLocaleLowerCase();
    }

    openHorseSearchPopover(event, riderOne) {
        if (this.popoverActive)
            return;

        if (riderOne && !this.selectedEntry.contestantOneId && this.selectedEntry.teammateHeader && (this.selectedEntry.isDraw || this.selectedEntry.isTba)) {
            this.alert.showError("Missing Contestant One", "You must select a contestant first.");
            return;
        }

        if (!riderOne && !this.selectedEntry.contestantTwoId && !this.selectedEntry.teammateHeader && (this.selectedEntry.isDraw || this.selectedEntry.isTba)) {
            this.alert.showError("Missing Contestant Two", "You must select a contestant first.");
            return;
        }

        this.popoverActive = true;

        let popover = this.popoverController.create(SearchComponent, {
            config: {
                searchTitle: "Horse Search",
                horseSearch: true,
                userHorses: true,
                addNew: true
            },
            userIds: !riderOne ? [this.selectedEntry.contestantTwoId, this.selectedEntry.contestantOneId] : [this.selectedEntry.contestantOneId],
            userHorses: true,
            organizations: this.organizations
        }, { cssClass: 'app-search' });

        popover.present({ ev: event });

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null) {
                if (data.id) {
                    if (riderOne) {
                        this.selectedEntry.horseOneName = (data as Horse).name;
                        this.selectedEntry.horseOne = (data as Horse);
                        this.selectedEntry.horseOneId = (data as Horse).id;

                        if (this.showTeammate && this.selectedEntry.contestantTwo == null) {
                            setTimeout(() => {
                                this.focusElement(this.userTwoSearch);
                            }, 0)
                        }
                    } else {
                        this.selectedEntry.horseTwoName = (data as Horse).name;
                        this.selectedEntry.horseTwo = (data as Horse);
                        this.selectedEntry.horseTwoId = (data as Horse).id;
                    }
                } else {
                    if (this.popoverActive)
                        return;

                    this.popoverActive = true;

                    let popover = this.modalController.create(AddHorsePage, {
                        accountId: riderOne ? this.selectedEntry.contestantOneId : this.selectedEntry.contestantTwoId,
                        horse: data
                    }, { cssClass: 'page-add-horse' });

                    popover.present();

                    popover.onDidDismiss((data) => {
                        this.popoverActive = false;

                        if (data != null) {
                            if (riderOne) {
                                this.selectedEntry.horseOneName = (data as Horse).name;
                                this.selectedEntry.horseOne = (data as Horse);
                                this.selectedEntry.horseOneId = (data as Horse).id;

                                if (this.showTeammate && this.selectedEntry.contestantTwo == null) {
                                    setTimeout(() => {
                                        this.focusElement(this.userTwoSearch);
                                    }, 0)
                                }
                            } else {
                                this.selectedEntry.horseTwoName = (data as Horse).name;
                                this.selectedEntry.horseTwo = (data as Horse);
                                this.selectedEntry.horseTwoId = (data as Horse).id;
                            }
                        }
                    });
                }
            }
        });
    }

    setMemberships(account: Account) {
        let rodeoMemberships = this.rodeo.sanctionedOrganizations.flatMap(x => x.memberships);

        account.memberships.forEach((membership) => {
            membership.show = false;
        });

        console.log("account.memberships: ", account.memberships);

        rodeoMemberships.forEach(membership => {
            let accountMembership = account.memberships.find(x => x.membershipId == membership.id);

            if (accountMembership == null) {
                accountMembership = new AccountMembership();
                accountMembership.membership = membership;
                accountMembership.membershipId = membership.id;
                accountMembership.permit = false;
                accountMembership.id = null;
                accountMembership.show = true;

                account.memberships.push(accountMembership)
            } else {
                accountMembership.show = true;
            }

            if (membership.hasRiderOneHandicap) {
                var membershipHandicap = accountMembership.handicaps.find(x => x.riderOne === true);

                if (membershipHandicap == null) {
                    membershipHandicap = new MembershipHandicap();
                    membershipHandicap.riderOne = true;
                    membershipHandicap.eventType = this.rodeoEvent.eventType;
                    membershipHandicap.accountMembershipId = accountMembership.accountMembershipId;
                    accountMembership.handicaps.push(membershipHandicap);
                }
            }

            if (membership.hasRiderTwoHandicap) {
                var membershipHandicap = accountMembership.handicaps.find(x => x.riderOne === false);

                if (membershipHandicap == null) {
                    membershipHandicap = new MembershipHandicap();
                    membershipHandicap.riderOne = false;
                    membershipHandicap.eventType = this.rodeoEvent.eventType;
                    membershipHandicap.accountMembershipId = accountMembership.accountMembershipId;
                    accountMembership.handicaps.push(membershipHandicap);
                }
            }
        });
    }

    openContestantOneSearch(searchEvent) {
        let callback = (data) => {
            if (data && data.buddies && data.buddies.length > 0) {
                /*
                if (data.buddies[0].firstName === 'Draw' || data.buddies[0].firstName === 'Tba') {
                    this.teammateName = data.buddies[0].firstName;
                    this.selectedEntry.isDraw = data.buddies[0].firstName === 'Draw';
                    this.selectedEntry.isTba = data.buddies[0].firstName === 'Tba';
                    this.selectedEntry.contestantOne = null;
                    this.selectedEntry.contestantOneId = null;
                } else 
                */{
                    this.contestantOneName = data.buddies[0].firstName + ' ' + data.buddies[0].lastName;
                    this.selectedEntry.contestantOneId = data.buddies[0].id;
                    this.selectedEntry.contestantOne = data.buddies[0];
                    this.setMemberships(this.selectedEntry.contestantOne);
                    this.userService.getHorses(this.selectedEntry.contestantOneId)
                        .then(data => {
                            this.horseOnes = data as Horse[];

                            if (this.rodeoEvent.handicapLimit && this.rodeoEvent.handicapLimit > 0) {
                                this.focusElement(this.userTwoSearch);
                            } else if (this.showHorseOne && !this.selectedEntry.horseOne) 
                                this.focusElement(this.horseOneSearch);
                        })
                        .catch(error => this.alert.showError('Error', 'Unable to retrieve search results: ' + error));

                    this.updatePurchaseOrder();
                }
            }
        }
        
        this.openUserSearch(searchEvent, (this.selectedEntry.teammateHeader ? this.rodeoEvent.configuration.runs.slotTwoLabel : this.rodeoEvent.configuration.runs.slotOneLabel) + ' Search', callback);
    }

    openContestantTwoSearch(searchEvent) {
        let callback = (data) => {
            if (data && data.buddies && data.buddies.length > 0) {
                if (data.buddies[0].firstName === 'Draw' || data.buddies[0].firstName === 'Tba') {
                    this.teammateName = data.buddies[0].firstName;
                    this.selectedEntry.isDraw = data.buddies[0].firstName === 'Draw';
                    this.selectedEntry.isTba = data.buddies[0].firstName === 'Tba';
                    this.selectedEntry.contestantTwo = null;
                    this.selectedEntry.contestantTwoId = null;
                } else {
                    this.teammateName = data.buddies[0].firstName + ' ' + data.buddies[0].lastName;

                    this.selectedEntry.isDraw = false;
                    this.selectedEntry.isTba = false;

                    if (this.swapTeammate) {
                        this.selectedEntry.contestantOneId = data.buddies[0].id;
                    }
                    else {
                        this.selectedEntry.contestantTwoId = data.buddies[0].id;
                        this.selectedEntry.contestantTwo = data.buddies[0];
                        this.setMemberships(this.selectedEntry.contestantTwo);
                        this.userService.getHorses(this.selectedEntry.contestantTwoId)
                            .then(data => {
                                this.horseOnes = data as Horse[];

                                if (this.showHorseTwo && !this.selectedEntry.horseTwo && this.rodeoEvent.idealTeamRank == 0)
                                    this.focusElement(this.horseTwoSearch);
                            })
                            .catch(error => this.alert.showError('Error', 'Unable to retrieve search results: ' + error));
                    }
                }

                this.updatePurchaseOrder();
            }
        }
 
        this.openUserSearch(searchEvent, (this.selectedEntry.teammateHeader ? this.rodeoEvent.configuration.runs.slotOneLabel : this.rodeoEvent.configuration.runs.slotTwoLabel) + ' Search', callback, this.rodeoEvent.allowDrawAll || this.rodeoEvent.ropingFormat == 'PickOrDraw' || this.rodeoEvent.ropingFormat == 'Draw', this.rodeoEvent.allowTBA);
    }

    updatePurchaseOrder() {
        if (this.purchaseOrder)
            this.purchaseOrder.updateRegistration();
    }

    openBuddySearch(searchEvent) {
        let callback = (data) => {
            if (data && data.buddyRequest) {
                this.selectedEntry.buddyRequests = this.selectedEntry.buddyRequests.concat(data.buddyRequest);
                this.selectedEntry.buddies = this.selectedEntry.buddies.concat(data.buddyRequest.buddy);
            }
        }

        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(BuddyEntry, {
            rodeo: this.rodeo,
            rodeoEvent: this.rodeoEvent
        }, { cssClass: 'buddy-entry ' });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            callback(data);
        })
    }

    async simpleBuddySearch() {
        const callback = async (data) => {
            if (data && data.buddies && data.buddies.length > 0) {
                if (data.buddies[0].id) {
                    this.selectedEntry.buddies.push(data.buddies[0]);
                } else {
                    data.birthDate = '2022-01-01';

                    let entryModal = this.popoverController.create(NewMemberPage, { account: null, organizations: this.organizations, callback: callback, firstName: data.buddies[0].firstName, lastName: data.buddies[0].lastName }, { cssClass: 'page-new-member', enableBackdropDismiss: true });

                    entryModal.present();
                    entryModal.onDidDismiss((data2) => {
                        this.popoverActive = false;

                        if (data2 != null) {
                            if (data2.id) {
                                this.selectedEntry.buddies.push(data2);
                                console.log("buddies: ", this.selectedEntry.buddies);
                            }
                        }
                    });
                }
            }
        };

        this.openUserSearch(null, 'Teammate Search', callback);
    }

    openUserSearch(searchEvent, title, callback, allowDraw = false, allowTba = false) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(UserSearchPopover, {
            searchTitle: title,
            organizations: this.organizations,
            allowDraw: allowDraw,
            allowTba: allowTba,
        }, { cssClass: 'user-search' });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            callback(data);
        })
    }

    toggleTeammateRole() {
        this.selectedEntry.teammateHeader = !this.selectedEntry.teammateHeader;
    }

    previousHole() {
        if (this.drawPosition > 1)
            this.drawPosition--;
        else
            return;

        const schedule = this.rodeo.rodeoEvents[this.rodeo.rodeoEvents.indexOf(this.rodeoEvent)].schedules[0];
        let runs = [];

        if (schedule.scheduleGroupId && schedule.scheduleGroupId != 0) {
            runs = this.rodeo.rodeoEvents.flatMap(x => x.schedules)
                .filter(x => x.scheduleGroupId == schedule.scheduleGroupId).flatMap(x => x.runs);
        } else {
            runs = schedule.runs;
        }

        runs = runs.filter(x => x.round == 1).map(x => x.number);
        runs = runs.concat(this.addedRunNumbers);
        
        runs.sort((a, b) => {
            if (a < b)
                return 1;
            else if (a > b)
                return -1;

            return 0;
        });

        let i = this.drawPosition;
        runs.forEach((run) => {
            if (run == i)
                i--;
            else
                return;
        });

        this.drawPosition = i;
    }

    nextHole() {
        this.drawPosition++;

        const schedule = this.rodeo.rodeoEvents[this.rodeo.rodeoEvents.indexOf(this.rodeoEvent)].schedules[0];
        let runs = [];

        if (schedule.scheduleGroupId && schedule.scheduleGroupId != 0) {
            runs = this.rodeo.rodeoEvents.flatMap(x => x.schedules)
                .filter(x => x.scheduleGroupId == schedule.scheduleGroupId).flatMap(x => x.runs);
        } else {
            runs = schedule.runs;
        }

        runs = runs.filter(x => x.round == 1).map(x => x.number);
        runs = runs.concat(this.addedRunNumbers);
        runs.sort((a, b) => {
            if (a < b)
                return -1;
            else if (a > b)
                return 1;

            return 0;
        });

        let i = this.drawPosition;
        runs.forEach((run) => {
            if (run == i)
                i++;
            else
                return;
        });

        this.drawPosition = i;
    }

    editHorse(horse: Horse) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let horseOne = horse == this.selectedEntry.horseOne;

        let popover = this.modalController.create(AddHorsePage, {
            accountId: this.selectedEntry.contestantOneId,
            horse: horse
        }, { cssClass: 'page-add-horse' });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null) {
                horse = (data as Horse);

                if (horseOne) {
                    this.selectedEntry.horseOneName = (data as Horse).name;
                    this.selectedEntry.horseOneId = (data as Horse).id;
                } else {
                    this.selectedEntry.horseTwoName = (data as Horse).name;
                    this.selectedEntry.horseTwoId = (data as Horse).id;
                }
            }
        })
    }

    addHorseOne() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.modalController.create(AddHorsePage, {
            accountId: this.selectedEntry.contestantOneId
        }, { cssClass: 'page-add-horse' });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null) {
                this.selectedEntry.horseOneName = (data as Horse).name;
                this.selectedEntry.horseOneId = (data as Horse).id;
                this.horseOnes.push(data);
            }
        })
    }

    addHorseTwo() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.modalController.create(AddHorsePage, {
            accountId: this.selectedEntry.contestantTwoId
        }, { cssClass: 'page-add-horse' });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null) {
                this.selectedEntry.horseTwoName = (data as Horse).name;
                this.selectedEntry.horseTwoId = (data as Horse).id;
                this.horseTwos.push(data.horse);
            }
        })
    }

    addPayment() {
        if (!this.selectedEntry.payments)
            this.selectedEntry.payments = [];

        this.selectedEntry.payments.push(new RegistrationPayment());
    }

    removeBuddy(buddy: Account) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let alert = this.alertController.create({
            title: 'Confirm Buddy Removal',
            message: 'Do you want to remove ' + buddy.firstName + ' ' + buddy.lastName + ' as a buddy?',
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: 'Yes',
                    handler: () => {
                        this.selectedEntry.buddies = this.selectedEntry.buddies.filter(x => x.id != buddy.id);
                        this.selectedEntry.buddyRequests = this.selectedEntry.buddyRequests.filter(x => x.buddy.id != buddy.id);
                    }
                }]
        });

        alert.present();

        alert.onDidDismiss(() => {
            this.popoverActive = false;
        })
    }

    setupNewEntry() {
        this.selectedEntry = new RodeoEventRegistration();

        this.drawPosition = 0;
        this.teammateName = null;
        this.contestantOneName = null;
        this.buddyList = null;
        this.selectedEntry.horseOneName = '';
        this.selectedEntry.horseTwoName = '';
        this.existingExhibitionsCounts = [];

        if (this.rodeoEvent != null) {
            this.selectedEntry.lateFee = new Date() > new Date(this.rodeo.lateRegistrationStartDate);
            this.selectedEntry.rodeoEventId = this.rodeoEvent.id;
            this.selectedEntry.scheduleIds.push(this.rodeoEvent.schedules[0].id);

            if (this.rodeoEvent.schedules.filter(x => !x.blockPreference).length > 1) {
                var nextSchedule = this.rodeoEvent.schedules.filter(x => !x.blockPreference)[1];
                this.selectedEntry.scheduleIds.push(nextSchedule.id);
            } else if (this.rodeoEvent.preferencesAllowed > 1 && this.rodeoEvent.schedules.filter(x => !x.blockPreference).length > 1) {
                this.selectedEntry.secondPrefTurnout = true;
            } else {
                this.selectedEntry.secondPrefTurnout = false;
            }
        }

        if (this.rodeo.hotelRooms.length > 0) {
            // let hotelRoom = new RegistrationHotelRoom();
            // hotelRoom.roomType = this.entries.length == 0 ? 'King' : 'None';
            // hotelRoom.quantity = 1;

            if (!this.selectedEntry.hotelRooms)
                this.selectedEntry.hotelRooms = [];

            // this.selectedEntry.hotelRooms.push(hotelRoom);
        }

        if (this.rodeo.clothing.length > 0) {
            let clothing = new RegistrationClothing();
            clothing.size = 'M';
            clothing.quantity = 1;

            if (!this.selectedEntry.clothing)
                this.selectedEntry.clothing = [];

            this.selectedEntry.clothing.push(clothing);
        }

        this.updateEvents();
    }

    addHotelRoom() {
        this.selectedEntry.hotelRooms.push({
            id: 0,
            rodeoId: this.rodeo.id,
            rodeoEventId: this.selectedEntry.rodeoEventId,
            quantity: 1,
            status: 0,
            reservationStartDate: undefined,
            reservationEndDate: undefined,
            roomType: undefined,
            rodeoHotelRoomConfigId: undefined,
            accountId: this.selectedEntry.contestantOneId,
            stayoverOptIn: false,
            primaryGuestName: this.selectedEntry.contestantOne ? `${this.selectedEntry.contestantOne.firstName} ${this.selectedEntry.contestantOne.lastName}` : undefined,
            primaryGuestEmailAddress: this.selectedEntry.contestantOne ? `${this.selectedEntry.contestantOne.emailAddress}` : undefined,
            primaryGuestBirthDate: this.selectedEntry.contestantOne ? new Date(this.selectedEntry.contestantOne.birthDate).toISOString().slice(0, 10) : undefined,
            nightsComped: 0,
        });
    }

    selectHotelRoom(id: number, index: number) {
        const hotelRoom = this.selectedEntry.hotelRooms[index];
        const room = this.rodeo.hotelRooms.find(x => x.id == id);
        hotelRoom.roomType = room.displayName;
        hotelRoom.reservationStartDate = room.checkinDate;
        hotelRoom.reservationEndDate = room.checkoutDate;
    }

    getHotelRoomConfig(id: number) {
        return this.rodeo.hotelRooms.find(x => x.id == id);
    }

    removeHotelRoom(index) {
        this.selectedEntry.hotelRooms.splice(index, 1);
    }

    checkHandicapRules() {
        let errorString = "";
        let rodeoMemberships = this.rodeo.sanctionedOrganizations.flatMap(x => x.memberships);
        var riderOneHandicap = null;
        var riderTwoHandicap = null;

        rodeoMemberships.forEach(membership => {
            let contestantOneMembership = this.selectedEntry.contestantOne.memberships.find(x => x.membershipId == membership.id);

            if (contestantOneMembership != null) {
                riderOneHandicap = contestantOneMembership.handicaps.find(x => x.riderOne === !this.selectedEntry.teammateHeader);

                if (riderOneHandicap != null)
                    riderOneHandicap.error = false;
            }
            
            if (this.selectedEntry.contestantTwo) {
                let contestantTwoMembership = this.selectedEntry.contestantTwo.memberships.find(x => x.membershipId == membership.id);

                if (contestantTwoMembership != null) {
                    riderTwoHandicap = contestantTwoMembership.handicaps.find(x => x.riderOne === this.selectedEntry.teammateHeader);
                    
                    if (riderTwoHandicap != null)
                        riderTwoHandicap.error = false;
                }
            }
        });

        if (this.rodeoEvent.handicapFloor) {
            if (riderOneHandicap && +riderOneHandicap.handicap < this.rodeoEvent.handicapFloor) {
                riderOneHandicap.error = true;
                errorString += `<li>${this.selectedEntry.contestantOne.firstName} ${this.selectedEntry.contestantOne.lastName}'s ${this.selectedEntry.teammateHeader ? 'Heeler' : 'Header'} handicap is too low.</li>`;
            }

            if (riderTwoHandicap && +riderTwoHandicap.handicap < this.rodeoEvent.handicapFloor) {
                riderTwoHandicap.error = true;
                errorString += `<li>${this.selectedEntry.contestantTwo.firstName} ${this.selectedEntry.contestantTwo.lastName}'s ${this.selectedEntry.teammateHeader ? 'Header' : 'Heeler'} handicap is too low.</li>`;
            }
        }

        if (this.rodeoEvent.handicapCap) {
            if (riderOneHandicap && +riderOneHandicap.handicap > this.rodeoEvent.handicapCap) {
                riderOneHandicap.error = true;
                errorString += `<li>${this.selectedEntry.contestantOne.firstName} ${this.selectedEntry.contestantOne.lastName}'s ${this.selectedEntry.teammateHeader ? 'Heeler' : 'Header'} handicap is too high.</li>`;
            }

            if (riderTwoHandicap && +riderTwoHandicap.handicap > this.rodeoEvent.handicapCap) {
                riderTwoHandicap.error = true;
                errorString += `<li>${this.selectedEntry.contestantTwo.firstName} ${this.selectedEntry.contestantTwo.lastName}'s ${this.selectedEntry.teammateHeader ? 'Header' : 'Heeler'} handicap is too high.</li>`;
            }
        }

        if (this.rodeoEvent.handicapLimit) {
            if (riderOneHandicap && riderTwoHandicap && !this.rodeoEvent.slide) {
                if (+riderOneHandicap.handicap + +riderTwoHandicap.handicap > this.rodeoEvent.handicapLimit) {
                    riderOneHandicap.error = true;
                    riderTwoHandicap.error = true;
                    errorString += `<li>Your combined team handicap is too high.</li>`;
                }
            }
        }

        return errorString;
    }

    delete() {
        let title = 'Entry Removal';
        let message = 'Are you sure you want to remove this entry?';

        if (this.selectedEntry.run) {
            title = 'Entry and Run Removal';
            message = 'Are you sure you want to remove this entry and the associated run?';
        }

        let finishedDeletingCallback = () => {
            this.setupNewEntry();
            this.availableEventTypes = this.rodeo.rodeoEvents;
        }

        let alert = this.alertController.create({
            title: title,
            message: message,
            buttons: [
                {
                    text: 'Yes',
                    handler: () => {
                        this.entryService.deleteEntry(this.selectedEntry.id)
                            .then((data: any) => {
                                if (this.selectedEntry.run) {
                                    this.runService.deleteRun(this.selectedEntry.run.id)
                                        .then(data => {
                                            finishedDeletingCallback();
                                        }), error => {
                                            this.alert.showError("Run Removal Error", error);
                                        };
                                } else {
                                    finishedDeletingCallback();
                                }

                                if (data && data.message) {
                                    this.alert.showError('Run Removal Error', data.message);
                                    //show error but don't stop processing runs
                                }
                            }), error => {
                                this.alert.showError("Entry Removal Error", error);
                            };
                    }
                },
                {
                    text: 'No',
                    role: 'cancel',
                    handler: () => {
                        this.availableEventTypes = this.rodeo.rodeoEvents;
                    }
                }]
        });

        alert.present();
    }

    checkBuddySet(entry: RodeoEventRegistration) {
        // console.log('Checking entry', entry);
        // Check existing entry buddies
        for (let i = 0; i < entry.buddies.length; i++) {
            if (!this.buddySet.has(entry.buddies[i].id)) {
                this.buddySet.add(entry.buddies[i].id);
            }
        }
        // Check entry buddy requests
        for (let i = 0; i < entry.buddyRequests.length; i++) {
            if (!this.buddySet.has(entry.buddyRequests[i].buddy.id)) {
                this.buddySet.add(entry.buddyRequests[i].buddy.id);
            }
            
            if (entry.buddyRequests[i].buddyTeammate != null && !this.buddySet.has(entry.buddyRequests[i].buddyTeammate.id)) {
                this.buddySet.add(entry.buddyRequests[i].buddyTeammate.id);
            }
        }
        // Remove contestant one from set
        if (this.buddySet.has(entry.contestantOne.id)) {
            this.buddySet.delete(entry.contestantOne.id);
        }
        // Set size > buddy max ? throw error
        if (this.buddySet.size > this.rodeo.buddyMax) {
            return `You cannot have more than ${this.rodeo.buddyMax} buddies for this rodeo.`;
        } else {
            return null;
        }
    }

    create(pay: boolean) {
        let entryInvalid = false;

        let invalidMessage = "<div style=\"text-align: left;line-height: .75rem;\">";
        for (let entry of this.entries) {
            let currentEntryInvalidMessage = "<p><b>Entry #" + (this.entries.indexOf(entry) + 1) + "</b></p><ul>";

            if (!entry.contestantOneId) {
                currentEntryInvalidMessage += "<li>You must select a rider.</li>";
                entryInvalid = true;
            }

            if (this.rodeoEvent.eventType == 'TeamRoping' && !entry.isDraw && !entry.isTba && (entry.contestantTwoId == null || entry.contestantTwoId == undefined)) {
                currentEntryInvalidMessage += "<li>You must select a teammate.</li>";
                entryInvalid = true;
            }

            if (this.rodeoEvent.eventType == 'TeamRoping' && (entry.contestantTwoId == entry.contestantOneId)) {
                currentEntryInvalidMessage += "<li>You cannot select yourself as your teammate.</li>";
                entryInvalid = true;
            }

            if (this.rodeoEvent.horseRequired && entry.horseOneId == null) {
                currentEntryInvalidMessage += "<li>You must select a horse.</li>";
                entryInvalid = true;
            }

            if (!this.selectedEntry.allPreferences && !entry.secondPrefTurnout && entry.scheduleIds.length < 2 && this.rodeoEvent.schedules.length > 1 && this.rodeoEvent.preferencesAllowed > 1) {
                currentEntryInvalidMessage += "<li>You must select a second preference.</li>";
                entryInvalid = true;
            }

            if (this.rodeoEvent.teammateEntry && (!entry.buddies || entry.buddies.length == 0)) {
                entryInvalid = true;
                currentEntryInvalidMessage += `<li>A teammate is required for ${this.rodeoEvent.displayName}.</li>`;
            }

            // Only check buddy set if any buddies are allowed
            if (this.rodeo.buddyMax > 0) {
                const buddyResponse = this.checkBuddySet(entry);
                if (buddyResponse != null) {
                    entryInvalid = true;
                    currentEntryInvalidMessage += `<li>${buddyResponse}</li>`;
                }
            }

            invalidMessage += currentEntryInvalidMessage + "</ul>";
        }

        if (entryInvalid) {
            this.alert.showError("Entry Errors", invalidMessage + "<br/><br/><p><b>If you need help call 903-287-7852!</b></p></div>");
            return;
        }

        this.selectedEntry.carryOvers = [];
        this.selectedCarryOvers.forEach((carryOver) => {
            let matchingCarryOver = this.selectedEntry.carryOvers.filter(x => x.rodeoEventId == carryOver.to.id)[0];
            if (!matchingCarryOver)
                this.selectedEntry.carryOvers.push({rodeoEventId: carryOver.to.id, lateFee: carryOver.lateFee} as RegistrationCarryOver);
            else {
                matchingCarryOver.lateFee = carryOver.lateFee;
            }
        });

        let loader = this.loadingController.create({
            content: (this.editing ? 'Editing' : 'Creating') + ' entry...',
        });

        loader.present();

        if (!this.addRun || !this.enableRunInfo)
            this.drawPosition = 0;

        if (this.editing) {
            this.entryService.staffUpdateEntry(this.selectedEntry, true, this.purchaseOrder.paymentMethod, this.drawPosition)
                .then(data => {
                    if ((data as any).message != null && (data as any).message != undefined) {
                        this.alert.showError("Entry Update Failed", (data as any).message);
                        loader.dismiss();
                    } 
                    
                    if (!(data as any).message || (data as any).message.includes('order could not be updated')) {
                        if (this.selectedEntry.run) {
                            var newEntry = data as RodeoEventRegistration;
                            this.selectedEntry.run.number = this.drawPosition;

                            if (newEntry.teammateHeader) {                                
                                this.selectedEntry.run.contestantTwoId = newEntry.contestantOneId;
                                this.selectedEntry.run.horseTwoId = newEntry.horseOneId;

                                if (!newEntry.isDraw && !newEntry.isTba) {
                                    this.selectedEntry.run.horseOneId = newEntry.horseTwoId;
                                    this.selectedEntry.run.contestantOneId = newEntry.contestantTwoId;
                                }
                            } else {
                                this.selectedEntry.run.contestantOneId = newEntry.contestantOneId;                                
                                this.selectedEntry.run.horseOneId = newEntry.horseOneId;
                                
                                if (!newEntry.isDraw && !newEntry.isTba) {
                                    this.selectedEntry.run.horseTwoId = newEntry.horseTwoId;
                                    this.selectedEntry.run.contestantTwoId = newEntry.contestantTwoId;
                                }
                            }
                        } else {
                            const message = this.drawPosition != 0 ? "Entry and runs were " : "Entry was";
                            
                            this.toast.create({
                                message: message,
                                duration: 1500,
                                position: 'middle'
                            }).present();
                        }

                        this.viewController.dismiss({ entries: [data] });
                        loader.dismiss();
                    }
                }, error => {
                    this.alert.showError("Entry Update Error", error);
                    loader.dismiss();
                });
        } else {
            let processEntryResponse = (data => {
                loader.dismiss();
                if ((data as any).message != null && (data as any).message != undefined) {
                    this.alert.showError("Entry Create Failed", (data as any).message);
                } else {
                    this.createdEntries.push(data);

                    if (this.rodeo.organization.paymentRequiredOnEntry && pay) {
                        let callback = (removed) => {
                            this.setupNewEntry();

                            if (removed)
                                return;

                            let addedEntry = (data as RodeoEventRegistration);

                            let alert = this.alertController.create({
                                title: 'Entry Confirmation - ' + addedEntry.confirmationCode,
                                message: 'Would you like to create more entries for this contestant?',
                                buttons: [
                                    {
                                        text: 'Yes',
                                        handler: () => {
                                            this.contestantOneName = addedEntry.contestantOne.firstName + ' ' + addedEntry.contestantOne.lastName;
                                            this.selectedEntry.contestantOne = addedEntry.contestantOne;
                                            this.selectedEntry.contestantOneId = addedEntry.contestantOneId;
                                            this.selectedEntry.buddies = addedEntry.buddies;
                                            this.selectedEntry.confirmationCode = addedEntry.confirmationCode;
                                            this.selectedEntry.allPreferences = addedEntry.allPreferences;
                                            this.selectedEntry.secondPrefTurnout = addedEntry.secondPrefTurnout;
                                            this.selectedEntry.thirdPrefTurnout = addedEntry.thirdPrefTurnout;
                                            this.teammateName = '';

                                            if (this.selectedEntry.scheduleIds.length > 1 && this.selectedEntry.secondPrefTurnout) { 
                                                this.selectedEntry.scheduleIds[1] = this.selectedEntry.scheduleIds[0];
                                            }
                                        }
                                    },
                                    {
                                        text: 'No',
                                        role: 'cancel',
                                        handler: () => {
                                            this.availableEventTypes = this.rodeo.rodeoEvents;
                                        }
                                    }]
                            });

                            alert.present();
                        };
                    } else {
                        let entryFollowUp = () => {
                            this.setupNewEntry();

                            let addedEntry = (data as RodeoEventRegistration[])[0];

                            let alert = this.alertController.create({
                                title: 'Entry Confirmation - ' + addedEntry.confirmationCode,
                                message: 'Would you like to create more entries for this contestant?',
                                buttons: [
                                    {
                                        text: 'Yes',
                                        handler: () => {
                                            this.contestantOneName = addedEntry.contestantOne.firstName + ' ' + addedEntry.contestantOne.lastName;
                                            this.selectedEntry.contestantOne = addedEntry.contestantOne;
                                            this.selectedEntry.contestantOneId = addedEntry.contestantOneId;
                                            this.selectedEntry.buddies = addedEntry.buddies;
                                            this.selectedEntry.confirmationCode = addedEntry.confirmationCode;
                                            this.selectedEntry.allPreferences = addedEntry.allPreferences;
                                            this.selectedEntry.secondPrefTurnout = addedEntry.secondPrefTurnout;
                                            this.selectedEntry.thirdPrefTurnout = addedEntry.thirdPrefTurnout;
                                            this.teammateName = '';

                                            if (this.selectedEntry.scheduleIds.length > 1 && this.selectedEntry.secondPrefTurnout) { 
                                                this.selectedEntry.scheduleIds[1] = this.selectedEntry.scheduleIds[0];
                                            }
                                        }
                                    },
                                    {
                                        text: 'No',
                                        role: 'cancel',
                                        handler: () => {
                                            this.availableEventTypes = this.rodeo.rodeoEvents;
                                        }
                                    }]
                            });

                            alert.present();
                        }

                        entryFollowUp();
                    }
                }
            });

            this.entryService.staffCreateEntries([this.selectedEntry], true, this.purchaseOrder.paymentMethod, this.drawPosition)
                .then((data => processEntryResponse(data))
                    , error => {
                        console.log({error});
                        this.alert.showError("Entry Create Error", error);
                        loader.dismiss();
                    });
        }
    }

    updatePayMethod() {
        if (this.purchaseOrder) {
            // this.purchaseOrder.paymentMethod = paymentMethod;
            this.purchaseOrder.updateRegistration();
        }
    }

    cancel() {
        if (this.editing) {
            this.selectedEntry.exhibitions = this.selectedEntry.exhibitions.filter(x => this.existingExhibitionsCounts[x.exhibitionId] != undefined);
            this.selectedEntry.exhibitions.forEach((regExhibition) => {
                regExhibition.entryCount = this.existingExhibitionsCounts[regExhibition.exhibitionId];
            });

            this.viewController.dismiss({ entries: [this.selectedEntry], runs: this.selectedEntry.run ? [this.selectedEntry.run] : [] });
        } else {
            this.viewController.dismiss({ entries: this.createdEntries });
        }
    }

    back() {
        if (this.editing) {
            this.viewController.dismiss({ entries: [this.selectedEntry], runs: this.selectedEntry.run ? [this.selectedEntry.run] : [] });
        } else {
            this.viewController.dismiss({ entries: this.createdEntries });
        }
    }

    _bdClick() {
        if (this.editing) {
            this.viewController.dismiss({ entries: [this.selectedEntry], runs: this.selectedEntry.run ? [this.selectedEntry.run] : [] });
        } else {
            return this.viewController.dismiss({ entries: this.createdEntries });
        }
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (!this.viewController.isLast() || this.popoverActive || AlertMessager.showingAlert)
            return;

        if (ev.keyCode === 27) {
            this._bdClick().catch((err) => {
                console.warn(err);
            });
        } else if (ev.keyCode === 13) {
            this.create(false);
        }
    }

    updateSidepots() {
        this.rodeoEventSidepots = new Set<RodeoEvent>();
        if (this.rodeoEvent.sidepots.length > 0)
            this.rodeoEventSidepots.add(this.rodeoEvent);

        this.selectedCarryOvers.forEach(carryOver => {
            if (carryOver.to.sidepots.length > 0)
                this.rodeoEventSidepots.add(carryOver.to);

            if (carryOver.lateFee == undefined) {
                carryOver.lateFee = new Date() > new Date(this.rodeo.lateRegistrationStartDate);
            }
        });

        this.updatePurchaseOrder();
    }

    exhibitionDisabled(exhibition) {
        return this.selectedExhibitions.some(y => y == exhibition.id) || exhibition.currentCount >= exhibition.maxRuns;
    }

    addNewExhibition() {
        let registrationExhibition = new RegistrationExhibition();
        registrationExhibition.entryCount = 1;
        registrationExhibition.exhibitionId = this.rodeo.exhibitions[0].id;
        registrationExhibition.registrationId = this.selectedEntry.id;

        this.selectedEntry.exhibitions.push(registrationExhibition);
    }

    updateSelectedExhibition(index: number) {
        let exhibition = this.rodeo.exhibitions.filter(x => x.id == this.selectedExhibitions[index])[0];
        this.selectedEntry.exhibitions[index].exhibitionId = exhibition.id;

        this.updatePurchaseOrder();
    }

    decreaseEntryCount(regExhibition) {
        if (regExhibition.entryCount > 1) {
            regExhibition.entryCount--;
        } else {
            let alert = this.alertController.create({
                title: 'Exhibition Removal',
                message: 'Are you sure you want to remove this exhibition?',
                buttons: [
                    {
                        text: 'Yes',
                        handler: () => {
                            this.selectedExhibitions = this.selectedExhibitions.filter(x => x != regExhibition.exhibitionId);
                            this.selectedEntry.exhibitions = this.selectedEntry.exhibitions.filter(x => x.exhibitionId != regExhibition.exhibitionId);
                        }
                    },
                    {
                        text: 'No',
                        role: 'cancel',
                        handler: () => {
                            this.availableEventTypes = this.rodeo.rodeoEvents;
                        }
                    }]
            });

            alert.present();
        }
    }

    getExhibitionSpotsLeft(exhibition, regExhibition) {
        return Math.max(0, exhibition.maxRuns - exhibition.currentCount - (regExhibition.exhibitionId == exhibition.id
            ? (regExhibition.entryCount + (this.existingExhibitionsCounts[exhibition.id]
                ? this.existingExhibitionsCounts[exhibition.id] : 0)) : 0));
    }

    increaseEntryCount(regExhibition) {
        let exhibition = this.rodeo.exhibitions.filter(x => x.id == regExhibition.exhibitionId)[0];

        var realCurrentCount = (exhibition.maxRuns - exhibition.currentCount);

        if (this.existingExhibitionsCounts[exhibition.id])
            realCurrentCount += this.existingExhibitionsCounts[exhibition.id];

        if (regExhibition.entryCount < realCurrentCount && regExhibition.entryCount < 6) {
            regExhibition.entryCount++;
        }
    }

    async viewEntryLogs(entry: any) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let rodeoEvent = this.rodeo.rodeoEvents.filter(x => x.id == entry.rodeoEventId)[0];

        let logs = await this.entryService.getEntryLogs(entry.id);

        let entryModal = this.modalController.create(EntryLogsPage, { rodeoEvent: rodeoEvent, logs: logs }, { cssClass: 'page-entry-logs', enableBackdropDismiss: false });

        entryModal.present();
        entryModal.onDidDismiss((data) => {
            this.popoverActive = false;
        });
    }

    addStallOrRv(useStall: boolean) {
        this.setEntryContestants();

        let reservations = useStall ? this.selectedEntry.stallReservations : this.selectedEntry.rvReservations;

        let account;

        if (!reservations) {
         reservations = [];
        }

        account = this.entryContestants.find(account => 
            !reservations.some(stall => account.id === stall.accountId)
        );

        if (!account) {
            //error
            return;
        }

        reservations.push({
            id: 0,
            quantity: 1,
            rodeoId: this.rodeo.id,
            accountId: account.id
        });

        if (useStall) {
            this.selectedEntry.stallReservations = reservations;
        } else {
            this.selectedEntry.rvReservations = reservations;
        } 
    }

    removeStallOrRv(useStalls, index) {
        if (useStalls) {
            this.selectedEntry.stallReservations.splice(index,1);
        } else {
            this.selectedEntry.rvReservations.splice(index,1);
        }
    }

    async showChangeRequestModal(selectedEntry: RodeoEventRegistration, rodeoEvent: RodeoEvent) {
        const loader = this.loadingController.create({
            content: ("Retrieving request data...")
        });

        loader.present();

        let request = selectedEntry.changeRequests.length > 0 ? selectedEntry.changeRequests[0] : undefined;
        let databaseEntry;

        if (request) {
            const existingRequest: any = await this.requestService.getRequest(request.id);

            if (existingRequest) {
                request = existingRequest;
                databaseEntry = await this.entryService.getEntry(request.registrationId);
            }
        }

        loader.dismiss();

        let requestModal = this.modalController.create(ChangeRequestDetailsComponent, {
            entry: databaseEntry ? databaseEntry : selectedEntry,
            run: selectedEntry.run ? selectedEntry.run : databaseEntry && databaseEntry.runs && databaseEntry.runs.length > 0 ? databaseEntry.runs[0] : undefined,
            rodeoEvent: rodeoEvent,
            rodeo: this.rodeo ? this.rodeo : await this.rodeoService.getRodeo(request.RodeoId),
            changeRequest: request,
            isEditing: request ? true : false,
            isNewRequest: request ? false : true,
            order: this.purchaseOrder.order
        }, { cssClass: 'page-entry-logs', enableBackdropDismiss: false });

        await requestModal.present();
        requestModal.onDidDismiss(async (data) => {
            // console.log('data from details modal', data);
            // console.log('order from request modal', data.order);

            if (data && data.didSave) {
                this.selectedEntry.status = data.request.registration.status;
                
                if (this.selectedEntry.status === 'TurnedOut') {
                    this.entryTurnedOut = true;
                } else {
                    this.entryTurnedOut = false;
                }

                let existingRequest = this.selectedEntry.changeRequests.find((x) => x.id === data.request.id);
                if (existingRequest) {
                    existingRequest = data.request;
                } else {
                    this.selectedEntry.changeRequests.push(data.request);
                }

                const foundEntry = this.entries.find(x => x.id === data.request.registration.id);

                let updatedRunInfo;

                // Both foundEntry and selectedEntry can have a run object on it
                if (this.selectedEntry.run || (foundEntry && foundEntry.run)) {
                    const updatedRun = await this.runService.getRun(this.selectedEntry.run ? this.selectedEntry.run.id : foundEntry.run.id);

                    if (updatedRun) {
                        this.selectedEntry.run = updatedRun;
                        updatedRunInfo = updatedRun;
                    }
                }

                if (foundEntry) {
                    Object.assign(foundEntry, data.request.registration);

                    if (updatedRunInfo) {
                        foundEntry.run = updatedRunInfo;
                    }
                }

                if (data.order) {
                    this.purchaseOrder.order = data.order;
                    this.purchaseOrder.displayRequest = this.purchaseOrder.formatRequest();
                }
            }
            this.popoverActive = false;
        });
    }

    private setEntryContestants() {
        if (this.selectedEntry.contestantOne) {
            this.entryContestants = [this.selectedEntry.contestantOne];
        } else {
            this.entryContestants = [];
        }

        if (this.selectedEntry.contestantTwo) {
            this.entryContestants.push(this.selectedEntry.contestantTwo);
        }
        
        if (this.selectedEntry.buddies) {
            const uniqueIds = new Set(this.selectedEntry.buddies.map(x => x.id));
            this.entryContestants.push(...this.selectedEntry.buddies.filter(x => uniqueIds.has(x.id) && x.id != this.selectedEntry.contestantOneId && x.id != this.selectedEntry.contestantTwoId));
        }
        
        this.entryContestantsMap = {};
        this.entryContestants.forEach(x => {
            this.entryContestantsMap[x.id] = x;
        });
    }
}
export function ageValidator(minAge: number) {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null; // return null if there's no value
      }
      
      const birthdate = new Date(control.value);
      const today = new Date();
      let age = today.getFullYear() - birthdate.getFullYear();
      const monthDiff = today.getMonth() - birthdate.getMonth();
      const dayDiff = today.getDate() - birthdate.getDate();
  
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
      }
  
      return age >= minAge ? null : { ageInvalid: true };
    };
  }


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/entries/new-entry.ts